import app from '../../common/app';
import extractText from '../utils/extractText';

/**
 * The `username` helper displays a user's username in a <span className="username">
 * tag. If the user doesn't exist, the username will be displayed as [deleted].
 */
export default function username(user, transformer) {
  const name = user && user.displayName() || extractText(app.translator.trans('core.lib.username.deleted_text'));
  const children = transformer ? transformer(name) : name;
  return m("span", {
    className: "username"
  }, children);
}
flarum.reg.add('core', 'common/helpers/username', username);